<form [formGroup]="appleSettingsForm" autocomplete="off" id="appleSettingsWrapper" class="genieSettingsWrapper" novalidate (ngSubmit)="onSubmit()">
  <div class="header-section">
    <p class="apple_dist">{{ 'Apple Distribution' | translate }}</p>
    <p class="core_cred">{{ 'Core credentials required to publish and update your app on the App Store.' | translate }}</p>
  </div>

  <div class="appleContainer">
    <!-- Apple Details Section -->
    <div class="section-card">
      <div class="card-header">
        <h3>{{ 'Apple Details' | translate }}</h3>
      </div>

      <div class="card-body">
        <div class="fields-grid">
          <!-- Apple Key ID -->
          <div class="field-wrapper">
            <div class="field-label-row">
              <label>{{ 'Apple Key ID' | translate }}</label>
              <a href="https://appstoreconnect.apple.com/access/integrations/api" target="_blank">
                {{ 'Get from Here' | translate }}
                <img src="assets/icons/External_link.svg" [alt]="'External link' | translate" />
              </a>
            </div>
            <div class="genie-input">
              <input type="text" [placeholder]="'ABCD98765E' | translate" formControlName="key_id" [value]="appleSettingsData?.key_id | trim" />
            </div>
          </div>
          <!-- Apple Issuer ID -->
          <div class="field-wrapper">
            <div class="field-label-row">
              <label>{{ 'Apple Issuer ID' | translate }}</label>
              <a href="https://appstoreconnect.apple.com/access/integrations/api" target="_blank">
                {{ 'Get from Here' | translate }}
                <img src="assets/icons/External_link.svg" [alt]="'External link' | translate" />
              </a>
            </div>
            <div class="genie-input">
              <input type="text" [placeholder]="'1321wer-6545-7894-aasa-9876543ab123' | translate" formControlName="issuer_id" [value]="appleSettingsData?.issuer_id | trim" />
            </div>
          </div>
          <!-- Team Name -->
          <div class="field-wrapper">
            <div class="field-label-row">
              <label>{{ 'Team Name' | translate }}</label>
              <a href="https://developer.apple.com/account/#!/membership/" target="_blank">
                {{ 'Get from Here' | translate }}
                <img src="assets/icons/External_link.svg" [alt]="'External link' | translate" />
              </a>
            </div>
            <div class="genie-input">
              <input type="text" [placeholder]="'John Doe' | translate" formControlName="team_name" [value]="appleSettingsData?.team_name | trim" />
            </div>
          </div>
          <!-- Team ID -->
          <div class="field-wrapper">
            <div class="field-label-row">
              <label>{{ 'Team ID' | translate }}</label>
              <a href="https://developer.apple.com/account/#!/membership/" target="_blank">
                {{ 'Get from Here' | translate }}
                <img src="assets/icons/External_link.svg" [alt]="'External link' | translate" />
              </a>
            </div>
            <div class="genie-input">
              <input type="text" [placeholder]="'A1BC23456D' | translate" formControlName="team_id" [value]="appleSettingsData?.team_id | trim" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Store Credentials Section -->
    <div class="section-card">
      <div class="card-header">
        <h3>{{ 'Store Credentials' | translate }}</h3>
      </div>
      <div class="card-body">
        <div class="fields-grid">
          <!-- iTunes Email -->
          <div class="field-wrapper">
            <div class="field-label-row">
              <label>{{ 'iTunes Email' | translate }}</label>
              <a href="https://appleid.apple.com/" target="_blank">
                {{ 'Get from Here' | translate }}
                <img src="assets/icons/External_link.svg" [alt]="'External link' | translate" />
              </a>
            </div>
            <div class="genie-input">
              <input type="email" [placeholder]="'info@yourwebsite.com' | translate" autocomplete="off" formControlName="email" [value]="appleSettingsData?.email | trim" />
            </div>
          </div>

          <!-- iTunes Password -->
          <div class="field-wrapper">
            <div class="field-label-row">
              <label>{{ 'iTunes Password' | translate }}</label>
            </div>
            <div class="genie-input">
              <input type="password" placeholder="" autocomplete="new-password" formControlName="itunes_password" [value]="appleSettingsData?.itunes_password | trim" />
            </div>
          </div>

          <!-- App-specific Password (Full Width) -->
          <div class="field-wrapper full-width-field">
            <div class="field-label-row">
              <label>{{ 'App-specific Password' | translate }}</label>
            </div>
            <div class="genie-input">
              <input type="text" [placeholder]="'abcd-efgh-ijkl-mnop' | translate" formControlName="app_specific_pass" [value]="appleSettingsData?.app_specific_pass | trim" />
            </div>
          </div>

          <!-- p8 Key File Upload Section -->
          <div class="upload-section">
            <div class="field-label-row">
              <label>{{ 'p8 Key File' | translate }}</label>
              <a href="https://appstoreconnect.apple.com/access/integrations/api" target="_blank">
                {{ 'Get from Here' | translate }}
                <img src="assets/icons/External_link.svg" [alt]="'External link' | translate" />
              </a>
            </div>

            <div class="upload-area" *ngIf="!appleSettingsData.key_filepath">
              <input type="file" formControlName="key_filepath" id="key_filepath" (change)="this.processFile($event, 'application/pkcs8', 'key_filepath')" accept="application/pkcs8,.p8" />
              <div class="upload-icon-circle">
                <svg width="47" height="47" viewBox="0 0 47 47" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="3.33301" y="3.33398" width="40" height="40" rx="20" fill="#ECF5F8" />
                  <rect x="3.33301" y="3.33398" width="40" height="40" rx="20" stroke="#F9FAFB" stroke-width="6.66667" />
                  <path
                    d="M20 26.6673L23.3333 23.334M23.3333 23.334L26.6667 26.6673M23.3333 23.334V30.834M30 27.2863C31.0179 26.4457 31.6667 25.1739 31.6667 23.7507C31.6667 21.2193 29.6146 19.1673 27.0833 19.1673C26.9012 19.1673 26.7309 19.0723 26.6384 18.9154C25.5517 17.0713 23.5454 15.834 21.25 15.834C17.7982 15.834 15 18.6322 15 22.084C15 23.8057 15.6962 25.3649 16.8225 26.4953"
                    stroke="url(#paint0_linear_3029_40085)"
                    stroke-width="1.66667"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <defs>
                    <linearGradient id="paint0_linear_3029_40085" x1="23.8178" y1="41.8996" x2="20.7349" y2="16.145" gradientUnits="userSpaceOnUse">
                      <stop stop-color="#7CEEE6" />
                      <stop offset="0.495192" stop-color="#3A95B9" />
                      <stop offset="0.990385" stop-color="#004691" />
                    </linearGradient>
                  </defs>
                </svg>
              </div>
              <!-- <div class="upload-icon">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
            </svg>
          </div> -->
              <div class="upload-text">{{ 'click to Upload' | translate }}</div>
              <div class="upload-hint">{{ 'AuthKey_XXXXXXXXX.p8 file from Apple Developer Portal' | translate }}</div>
            </div>

            <div *ngIf="appleSettingsData.key_filepath" class="insertedFile">
              <img src="assets/images/file.png" [alt]="'file icon' | translate" />
              <h3>{{ appleSettingsData.key_filepath }}</h3>
              <span (click)="removeFile('appleSettingsData.key_filepath')">✕</span>
            </div>
          </div>
        </div>


      </div>
    </div>
  </div>
</form>
